import { c as _c } from "react/compiler-runtime";
import usePDPGetStockAvailability from 'data-hooks/usePDPGetStockAvailability';
import useBackgroundProductBasicDetails from 'data-hooks/useProductBasicDetails/useBackgroundProductBasicDetails';
import useReadProductBasicDetails from 'data-hooks/useProductBasicDetails/useReadProductBasicDetails';
import usePDPCreateProductOptions from './usePDPCreateProductOptions';
import usePDPRedirectDoubleQuery from '../usePDPRedirectDoubleQuery';
const usePDPCreateContextValue = (t0, t1) => {
  const $ = _c(26);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    slug,
    isEditOrder: t3,
    isQuickView: t4,
    pdpIsModularBYOProduct: t5,
    pdpVariantSkuOverride: t6,
    productOptions: initialProductOptions
  } = t2;
  const isEditOrder = t3 === undefined ? false : t3;
  const isQuickView = t4 === undefined ? false : t4;
  const pdpIsModularBYOProduct = t5 === undefined ? false : t5;
  const pdpVariantSkuOverride = t6 === undefined ? null : t6;
  let t7;
  if ($[2] !== t1) {
    t7 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const {
    skip: t8
  } = t7;
  const skip = t8 === undefined ? false : t8;
  usePDPRedirectDoubleQuery();
  let t9;
  if ($[4] !== skip) {
    t9 = {
      skip
    };
    $[4] = skip;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const basicDetailsQueryRef = useBackgroundProductBasicDetails(null, slug, t9);
  const t10 = !isQuickView && !isEditOrder;
  let t11;
  if ($[6] !== basicDetailsQueryRef || $[7] !== initialProductOptions || $[8] !== pdpVariantSkuOverride || $[9] !== slug || $[10] !== t10) {
    t11 = {
      slug,
      basicDetailsQueryRef,
      pdpVariantSkuOverride,
      shouldUpdateQueryParam: t10,
      initialProductOptions
    };
    $[6] = basicDetailsQueryRef;
    $[7] = initialProductOptions;
    $[8] = pdpVariantSkuOverride;
    $[9] = slug;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== skip) {
    t12 = {
      skip
    };
    $[12] = skip;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const {
    atoms,
    productOptions
  } = usePDPCreateProductOptions(t11, t12);
  const basicDetails = useReadProductBasicDetails(basicDetailsQueryRef);
  let t13;
  if ($[14] !== basicDetails || $[15] !== productOptions) {
    t13 = {
      basicDetails,
      productOptions
    };
    $[14] = basicDetails;
    $[15] = productOptions;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  const stockAvailability = usePDPGetStockAvailability(t13);
  const t14 = basicDetails?.data?.id || null;
  let t15;
  if ($[17] !== atoms || $[18] !== basicDetails || $[19] !== pdpIsModularBYOProduct || $[20] !== pdpVariantSkuOverride || $[21] !== productOptions || $[22] !== slug || $[23] !== stockAvailability || $[24] !== t14) {
    t15 = {
      atoms,
      basicDetails,
      id: t14,
      pdpIsModularBYOProduct,
      pdpVariantSkuOverride,
      pdpIsAvailableInSizesOpen: true,
      productOptions,
      stockAvailability,
      slug
    };
    $[17] = atoms;
    $[18] = basicDetails;
    $[19] = pdpIsModularBYOProduct;
    $[20] = pdpVariantSkuOverride;
    $[21] = productOptions;
    $[22] = slug;
    $[23] = stockAvailability;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
};
export default usePDPCreateContextValue;